import {http} from "./api";
import {
  Resident,
  ResidentStatus,
  ResidentSubStatus,
} from "../pages/page-admin-residents/types";
import {CreateResidentDto} from "../pages/page-admin-residents-forms/types";
import {Value} from "@reside/forms";

export const SORT_RESIDENTS_BY = [
  "name",
  "date_of_birth",
  "created",
  "created_by",
] as const;

type SearchResidents = {
  facility_ids?: string[];
  search?: string;
  page?: number;
  page_size?: number;
  sort_by?: (typeof SORT_RESIDENTS_BY)[number];
  sort_direction?: "asc" | "desc";
  resident_status?: Array<ResidentStatus | ResidentSubStatus>;
  is_archived?: boolean;
  waiting_list?: boolean;
};
type LinkResidentToAdmission = {
  admission_id: string;
  resident_id: string;
};

/** Data required when looking up similar residents. */
export type SearchSimilarResidents = {
  organization_id: string;
  first_name: string | Value;
  last_name: string | Value;
  gender: string | Value;
  date_of_birth: Date | string;
};

const BASE_PATH = "/residents";

export const ResidentService = {
  getResidentsViaPost: (body: SearchResidents) =>
    http.post<{data: Resident[]; total_count: number}>(
      `${BASE_PATH}/search/`,
      body,
    ),
  linkResidentToAdmission: (body: LinkResidentToAdmission) =>
    http.post<Resident[]>(`${BASE_PATH}/link-admission/`, body),
  getOneResident: (resident_uuid: string) =>
    http.get<Resident>(`${BASE_PATH}/${resident_uuid}/`),
  createResident: (body: CreateResidentDto) =>
    http.post<Resident>(`${BASE_PATH}/`, body),
  editResident: (body: CreateResidentDto, resident_uuid: string) =>
    http.put<Resident>(`${BASE_PATH}/${resident_uuid}/`, body),
  showResident: (resident_uuid: string) =>
    http.patch<Resident>(`${BASE_PATH}/${resident_uuid}/activate/`),
  hideResident: (resident_uuid: string) =>
    http.delete<Resident>(`${BASE_PATH}/${resident_uuid}/`),
  getSimilarResidentsViaPost: (body: SearchSimilarResidents) =>
    http.post<{resident: Resident; match: string}[]>(
      `${BASE_PATH}/list-duplicates/`,
      body,
    ),
  getLinkedResidentId: (admission_uuid: string) =>
    http.get<{admission_id: string; resident_id: string | null}>(
      `${BASE_PATH}/admission/${admission_uuid}/`,
    ),
};
